import { useScript } from '@uidotdev/usehooks';
import { useEffect } from 'react';
import Spinner from 'modules/shared/circleSpinner';

type OrbitvuOptions = {
    // more options can be found here https://public.manuals.orbitvu.com/a/722288-orbitvu-viewer-parameters-reference
    ovus_folder: string;
    content2: 'yes';
    width: string;
    height: string;
    style: 1 | 2 | 3 | 4;
    html5_hint: 'yes' | 'no';
    nosize_ratio: string;
    teaser: 'onerotation';
    vmove: 'yes' | 'no';
    auto_rotate_dir: 'left';
    max_scale: number;
};

declare let inject_orbitvu: (containerId: string, scriptUrl: string, url: string, options: OrbitvuOptions) => void;

export default function OrbitvuPlayer({
    presentationContainerId = 'presentation1-container',
    directoryUrl,
    options = {
        ovus_folder: directoryUrl,
        content2: 'yes',
        width: 'auto',
        height: 'auto',
        style: 4,
        html5_hint: 'no',
        nosize_ratio: '1/1',
        teaser: 'onerotation',
        vmove: 'yes',
        auto_rotate_dir: 'left',
        max_scale: 2.5
    }
}: { presentationContainerId?: string; directoryUrl: string; options?: OrbitvuOptions }) {
    const scriptUrl = '/scripts/lib/orbitvu12/orbitvu.js';
    const status = useScript(scriptUrl, { removeOnUnmount: false });

    useEffect(() => {
        if (status === 'ready') {
            inject_orbitvu(presentationContainerId, scriptUrl, '', options);
        }
    }, [status]);

    if (status === 'loading') {
        return <Spinner size={80} />;
    }

    return <div id={presentationContainerId} />;
}
